var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.2 28.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #E6E6E6;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-4 {\n        clip-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.1,5v18.7c0,.9.7,1.6,1.6,1.6h18.7c.9,0,1.6-.7,1.6-1.6V5c0-.9-.7-1.6-1.6-1.6H4.8c-.9,0-1.6.7-1.6,1.6ZM17.4,24.2V4.4h6c.3,0,.5.2.5.5v18.7c0,.3-.2.5-.5.5h-6ZM4.2,5c0-.3.2-.5.5-.5h11.5v9.3h-6.5l2.2-2.2c.2-.2.2-.6,0-.8-.2-.2-.5-.2-.8,0l-3.2,3.2c-.2.2-.2.6,0,.8l3.1,3.1c.1.1.2.2.4.2s.3,0,.4-.2c.2-.2.2-.6,0-.8l-2.2-2.2h6.5v9.3H4.8c-.3,0-.5-.2-.5-.5V5ZM19,5.5h3.3c.3,0,.5.2.5.5s-.2.5-.5.5h-3.3c-.3,0-.5-.2-.5-.5s.2-.5.5-.5ZM19,7.7h3.3c.3,0,.5.2.5.6s-.2.5-.5.5h-3.3c-.3,0-.5-.2-.5-.5s.2-.6.5-.6ZM20.1,9.9h2.2c.3,0,.5.2.5.5s-.2.6-.5.6h-2.2c-.3,0-.5-.2-.5-.6s.2-.5.5-.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.1,
    y: 3.3,
    width: 22,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.1,
    y: 2.3,
    width: 24,
    height: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.c9a0ec95e412a4b7eb9018ce9c9e89bb.svg";
export { ForwardRef as ReactComponent };